module.exports = __webpack_public_path__ + "fonts/PT_Serif-Web-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/PT_Serif/PT_Serif-Web-Regular.ttf
// module id = 3451
// module chunks = 0